<template>
  <v-card class="text-xs-center">
    <h1 class="text-pagename">Staff management</h1>
    <userTable />
  </v-card>
</template>

<script>
import userTable from "@/components/back-office/UserManagement/UserTable.vue";
import { mapState } from "vuex";
export default {
  components: {
    userTable
  },
  computed: {
    ...mapState({
      recentPath: state => state.backOffice.recentRoutePath
    })
  },
  destroyed() {
    this.$store.commit("fetchUserBack/resetState");
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/"
      },
      {
        text: "Staff management",
        disabled: true,
        href: "/weserve_admin_login/control/-/usermanage"
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style>
</style>
